module.exports = {"140223100":"壶泉镇","140223101":"南村镇","140223102":"加斗镇","140223103":"作疃镇","140223104":"梁庄镇","140223200":"一斗泉乡","140223202":"蕉山乡","140223206":"宜兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140223.json
// module id = 366
// module chunks = 0